import {Component, Input} from '@angular/core';
import {DatePipe} from "@angular/common";
import {TranslatePipe} from "../../pipes/translate.pipe";

@Component({
    selector: 'app-divider-date',
    imports: [
        DatePipe,
        TranslatePipe
    ],
    templateUrl: './divider-date.component.html',
    styleUrl: './divider-date.component.scss'
})
export class DividerDateComponent {
  @Input() public date: Date = new Date();

  public today: Date = new Date();
  public yesterday: Date = new Date(new Date().setDate(new Date().getDate() - 1));
}
